<div class="sz-section-head">
  <span class="sz-section-head__label">{{ label() }}</span>
  @if (count() !== null) {
    <span class="sz-section-head__count">{{ count() }}</span>
  }
  <span class="sz-section-head__line" aria-hidden="true"></span>
  <div class="sz-section-head__end">
    <ng-content />
  </div>
</div>
